import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import CreateShipment from '@components/obsolete/shipment/CreateShipment.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';

interface ComponentProps {
}

const CreateShipmentPage: React.FC<ComponentProps> = () => {
  const { tr } = useTranslationLgs();
  return (
    <>
      <ResponsiveLayout title={tr(`create-shipment.createShipment`, `Create shipment`)}>{
        <CreateShipment />}</ResponsiveLayout>
    </>
  );
};

export default withAuthenticationRequired(CreateShipmentPage);
